import img from '../assets/Crypto Mehedi.jpg'
export const headerData = {
    name: 'Mehedi Hasan',
    title: "Hello! I am,",
    description: "I am  a professional and passionate programmer in my daily life. A quick learner with a self-learning attitude. I love to learn and explore new technologies and passionate about problem polving. ",
    image: img,
    imagebw: img
}